module.exports = __webpack_public_path__ + "img/product-card.33975707.png";